import { Vue, Component, Prop, Provide } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import style from './style.vue';
import NavMenu from './navMenu';
import Hot from './hot';
import Shop from './shop';
import ProductInfo from './productInfo';
import ShareConfig from './shareConfig';
import PersonalCenter from './personalCenter';
import AppHoverIcon from './appHoverIcon';
import ShiningShow from './shiningShow';
import OpenShow from '@/views/components/newDisplayConfig/openShow';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils } from '@/util';
const isset = QinggerLibUtils.isset;

export interface PhoneNavType {
  isDefault: boolean;
  icon: string;
  enable: boolean;
  text: string;
}

@Component({
  mixins: [style],
  components: {
    NavMenu,
    Hot,
    Shop,
    OpenAd: OpenShow,
    PersonalCenter,
    ProductInfo,
    ShareConfig,
    AppHoverIcon,
  },
})
export default class NewDisplayConfig extends Vue {
  tabsSelect = 'nav';

  loading = true;

  themeCode: number = null;

  // 网点组Id
  @Prop()
    sgId: number;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Provide()
  get mode() {
    return Number(this.$route.params.mode);
  }

  @Provide()
  get isMoreSite() {
    return Number(+this.$route.params.isMoreSite);
  }

  // 是否开启优惠券
  coupon = 0;

  // 网点 商品分类列表
  classList = [];

  @Provide()
  goodsClassList() {
    return this.classList;
  }

  @Provide()
  openCoupon() {
    return this.coupon;
  }

  siteId = 0;

  async mounted() {
    this.siteId = +this.$route.params.siteId;
    this.coupon = await this.getCouponConfig();
    this.siteId && (this.classList = await this.getGoodsClassList());
    const postParams = {
      sgId: this.sgId,
    };
    IPSService.decorationThemeColorInfo({ postParams }).then(
      (res: ItemObject) => {
        this.themeCode = +res.themeCode;
        this.loading = false;
      },
      () => {
        this.$message.error('获取主题失败');
        this.loading = false;
      },
    );
  }

  // 获取优惠券配置
  getCouponConfig() {
    return IPSService.siteGroupConfig({
      postParams: {
        sgId: +this.$route.params.sgId || +this.$route.params.id,
      },
    }).then((res) => {
      return res.isOpenExchangeCoupon || 0;
    });
  }

  getGoodsClassList() {
    return IPSService.siteClassList({
      postParams: {
        siteId: this.siteId,
      },
    }).then((response) => {
      return isset(response, 'list') ? response.list : [];
    });
  }

  render(h: CreateElement): VNode {
    return (
      <el-container class="new-display-config" v-loading={this.loading}>
        <el-aside width="100%">
          <el-tabs tab-position="left" class="el-tabs" v-model={this.tabsSelect}>
            <el-tab-pane label="导航菜单" class="el-tab-pane" name="nav">
              {this.themeCode && this.tabsSelect === 'nav' ? <NavMenu themeCode={this.themeCode} mode={this.mode} /> : ''}
            </el-tab-pane>
            <el-tab-pane label="HOT页" name="hot">
              {this.themeCode && this.tabsSelect === 'hot' ? <Hot themeCode={this.themeCode} sgId={Number.parseInt(this.$route.params.id) || Number.parseInt(this.$route.params.sgId)} fromPage={this.siteId ? 10 : 5} /> : ''}
            </el-tab-pane>
            <el-tab-pane label="商城页" name="shop">
              {this.themeCode && this.tabsSelect === 'shop' ? <Shop themeCode={this.themeCode} fromPage={this.siteId ? 6 : 1} /> : ''}
            </el-tab-pane>
            <el-tab-pane label="个人中心" name="personal">
              {this.themeCode && this.tabsSelect === 'personal' ? <PersonalCenter themeCode={this.themeCode} fromPage={this.siteId ? 7 : 2} mode={this.mode} /> : ''}
            </el-tab-pane>
            {this.mode === 2 && (
              <el-tab-pane label="闪屏广告" name="shiningAd">
                {this.themeCode && this.tabsSelect === 'shiningAd' ? <ShiningShow themeCode={this.themeCode} mode={this.mode} /> : ''}
              </el-tab-pane>
            )}
            {/* <el-tab-pane label="开屏广告" name="openAd">
              {this.themeCode && this.tabsSelect === 'openAd' ? <OpenShow themeCode={this.themeCode} sgId={Number.parseInt(this.$route.params.id) || Number.parseInt(this.$route.params.sgId)} coupon={this.coupon} classList={this.classList} siteId={this.siteId} siteCodes={[this.$route.params.code]} /> : ''}
            </el-tab-pane> */}
            <el-tab-pane label="商品详情" name="productInfo">
              {this.themeCode && this.tabsSelect === 'productInfo' ? <ProductInfo themeCode={this.themeCode} /> : ''}
            </el-tab-pane>
            {!!this.siteId && (
              <el-tab-pane label="悬浮图标" name="hoverIcon">
                {this.themeCode && this.tabsSelect === 'hoverIcon' ? <AppHoverIcon themeCode={this.themeCode} /> : <div />}
              </el-tab-pane>
            )}
            <el-tab-pane label="分享配置" name="shareConfig">
              {this.themeCode && this.tabsSelect === 'shareConfig' ? (
                <ShareConfig
                  themeCode={this.themeCode}
                  fromPage={this.$route.params.siteId ? 4 : 0}
                  postParams={{
                    sgId: Number.parseInt(this.$route.params.id || this.$route.params.sgId),
                    siteId: +this.siteId,
                  }}
                />
              ) : (
                ''
              )}
            </el-tab-pane>
          </el-tabs>
        </el-aside>
      </el-container>
    );
  }
}
